// import { Menu } from "./Menu";
// import { Attachment } from "./Attachment";
// import { DiscountIcon } from "./DiscountIcon";
// import { OverivewIcon } from "./Overview";
// import { ReportIcon } from "./ReportIcon";
// import { OrderIcon } from "./OrderIcon";
// import { LoyaltyIcon } from "./LoyaltyIcon";
// import { PosIcon } from "./PosIcon";
// import { SettingIcon } from "./SettingIcon";
// import { CollapseOpenIcon } from "./CollapseOpen";
// import { CollapseCloseIcon } from "./CollapseClose";
// import { Fork } from "../Fork";
// import DownArrow from "../ReportIcons/DownArrow";
// import UpArrow from "../ReportIcons/UpArrow";
import NovaExpanedLogo from "./NovaExpanedLogo";
// import { PlateronMinimisedLogo } from "./PlateronMininsedLogo";
// import { AddIcon } from "./AddIcon";
// import { CancelKeypad } from "./MobileCancelIcon";

const Icon = (props) => {
  switch (props.name.toLowerCase()) {
    // case "menu":
    //   return <Menu {...props} />;
    // case "attachment":
    //   return <Attachment {...props} />;
    // case "discount":
    //   return <DiscountIcon {...props} />;
    // case "overview":
    //   return <OverivewIcon {...props} />;
    // case "report":
    //   return <ReportIcon {...props} />;
    // case "order":
    //   return <OrderIcon {...props} />;
    // case "loyalty":
    //   return <LoyaltyIcon {...props} />;
    // case "posystem":
    //   return <PosIcon {...props} />;
    // case "setting":
    //   return <SettingIcon {...props} />;
    // case "collapseopen":
    //   return <CollapseOpenIcon {...props} />;
    // case "collapseclose":
    //   return <CollapseCloseIcon {...props} />;
    // case "fork":
    //   return <Fork {...props} />;
    // case "down-arrow":
    //   return <DownArrow {...props} />;
    // case "up-arrow":
    //   return <UpArrow {...props} />;

    case "nova-expaned-logo":
      return <NovaExpanedLogo {...props} />;
    // case "plateron-minised-logo":
    //   return <PlateronMinimisedLogo />;
    // case "add-icon-category":
    //   return <AddIcon />;
    // case "cancel-mobile-keypad":
    //   return <CancelKeypad />;

    default:
      return <div />;
  }
};

export { Icon };
